import "./FooterComponent.css"
const FooterComponent = (props) => {
    let {version,CompanyName } = props;

   return (
    <footer className="app-footer">
      <div className="footer-content">
        <p className="footer-version">v{version}</p>
        <div className="footer-text">{CompanyName}</div>
      </div>
    </footer>
  );

}
export default FooterComponent